module.exports = __webpack_public_path__ + "img/Sentrum.4b4d0aad.png";